<!--*****************************************************************
  * Copyright (c) Certus Software, 2022.                            *
  *                                                                 *
  * This unpublished material is proprietary to Certus Software.    *
  * All rights reserved. The methods and techniques described       *
  * herein are considered confidential and/or trade secrets.        *
  * Reproduction or distribution, in whole or in part, is forbidden *
  * except by express written permission of Certus Software.        *
  *****************************************************************-->

<div [@fadeInOutAnimation]="true" class="download-card nm-card {{cardsLayout}}">
  <h2 class="s-h3" *ngIf="cardTitle">{{cardTitle}}</h2>
  <button *ngIf="softwareChoiceIos || softwareChoiceIso || softwareChoiceCut || softwareChoiceApk" class="close-sidenav-btn" (click)="softwareChoiceIso = false;softwareChoiceIos = false;softwareChoiceCut = false;softwareChoiceApk = false;" [attr.aria-label]="('dashboard.section2.subtitle.backTo' | translate)">
    <span></span>
  </button>
  <div *ngIf="!softwareChoiceIos && !softwareChoiceIso && !softwareChoiceCut && !softwareChoiceApk" role="list">
    <div *ngIf="showSoftwareChoiceCut" class="download-item info-card" role="listitem">
      <img src="assets/img/icons/windows.svg" aria-hidden="true" alt="Windows">
      <div>
        <p class="small">{{'dashboard.section2.product1' | translate}}</p>
        <button class="pushable-icon orange-push" (click)="softwareChoiceCut = !softwareChoiceCut" [attr.aria-label]="('licenseValidation.step1.button' | translate) + ' ' + ('dashboard.section2.product1' | translate)">
          <span class="front">
            <span>{{'licenseValidation.step1.button' | translate}}</span><i class="download-icon"></i>
          </span>
        </button>
      </div>
    </div>
    <div *ngIf="showSoftwareChoiceIso && !hideMacosCecede" class="download-item info-card" role="listitem">
      <img src="assets/img/icons/apple.svg" aria-hidden="true" alt="Apple">
      <div>
        <p class="small">{{'dashboard.section2.product2' | translate}}</p>
        <button class="pushable-icon orange-push" (click)="softwareChoiceIso = !softwareChoiceIso" [attr.aria-label]="('licenseValidation.step1.button' | translate) + ' ' + ('dashboard.section2.product2' | translate)">
          <span class="front">
            <span>{{'licenseValidation.step1.button' | translate}}</span><i class="arrow-right"></i>
          </span>
        </button>
      </div>
    </div>
    <div *ngIf="showSoftwareChoiceIso && !hideLinuxCecede" class="download-item info-card" role="listitem">
      <img src="assets/img/icons/linux.svg" aria-hidden="true" alt="Linux">
      <div>
        <p class="small">{{'dashboard.section2.product3' | translate}}</p>
        <button class="pushable-icon orange-push" (click)="softwareChoiceIso = !softwareChoiceIso" [attr.aria-label]="('licenseValidation.step1.button' | translate) + ' ' + ('dashboard.section2.product3' | translate)">
          <span class="front">
            <span>{{'licenseValidation.step1.button' | translate}}</span><i class="arrow-right"></i>
          </span>
        </button>
      </div>
    </div>
    <div *ngIf="showSoftwareChoiceApk" class="download-item info-card" role="listitem">
      <img src="assets/img/icons/android.svg" aria-hidden="true" alt="Android">
      <div>
        <p class="small">{{'dashboard.section2.product4' | translate}}</p>
        <button class="pushable-icon orange-push" (click)="softwareChoiceApk = !softwareChoiceApk" [attr.aria-label]="('licenseValidation.step1.button' | translate) + ' ' + ('dashboard.section2.product4' | translate)">
          <span class="front">
            <span>{{'licenseValidation.step1.button' | translate}}</span><i class="download-icon"></i>
          </span>
        </button>
      </div>
    </div>
    <div *ngIf="showSoftwareChoiceIos" class="download-item info-card" role="listitem">
      <img src="assets/img/icons/ios.svg" aria-hidden="true" alt="iOS">
      <div>
        <p class="small">{{'dashboard.section2.product5' | translate}}</p>
        <button class="pushable-icon orange-push" (click)="softwareChoiceIos = !softwareChoiceIos" [attr.aria-label]="('licenseValidation.step1.button' | translate) + ' ' + ('dashboard.section2.product5' | translate)">
          <span class="front">
            <span>{{'licenseValidation.step1.button' | translate}}</span><i class="arrow-right"></i>
          </span>
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="softwareChoiceIso" class="software-choices" role="list">
    <div class="download-choice info-card" role="listitem">
      <img class="hdd-img" src="assets/img/icons/hdd.svg" aria-hidden="true" alt="CECE Drive Eraser">
      <div>
        <p class="large">{{'dashboard.section2.subtitle.cecede' | translate}}</p>
        <p class="extra-small"><strong>{{'dashboard.section2.subtitle.sha' | translate}} </strong> {{downloadsDetails?.ceceApp.checksum}}</p>
        <div class="btn-h">
          <a href="{{downloadsDetails?.ceceApp.link}}" class="pushable-icon orange-push" [attr.aria-label]="('dashboard.section2.subtitle.cecede' | translate)">
            <span class="front">
              <span>{{'licenseValidation.step1.button' | translate}}</span><i class="download-icon"></i>
            </span>
          </a>
        </div>
      </div>
    </div>
    <div *ngIf="!showSoftwareChoiceCecedeOnly" class="download-choice info-card" role="listitem">
      <img src="assets/img/icons/ios.svg" aria-hidden="true" alt="iOS">
      <div>
        <p class="large">{{'dashboard.section2.subtitle.ceceie' | translate}}</p>
        <p class="extra-small"><strong>{{'dashboard.section2.subtitle.sha' | translate}}</strong> {{downloadsDetails?.ceceieApp.checksum}}</p>
        <div class="btn-h">
          <a href="{{downloadsDetails?.ceceieApp.link}}" class="pushable-icon orange-push" [attr.aria-label]="('dashboard.section2.subtitle.ceceie' | translate)">
            <span class="front">
              <span>{{'licenseValidation.step1.button' | translate}}</span><i class="download-icon"></i>
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="softwareChoiceIos" class="software-choices" role="list">
    <div class="download-choice info-card" role="listitem">
      <img src="assets/img/icons/windows.svg" aria-hidden="true" alt="Windows">
      <div>
        <p class="large">{{'dashboard.section2.subtitle.ceceut' | translate}}</p>
        <p class="extra-small"><strong>{{'dashboard.section2.subtitle.sha' | translate}}</strong> {{cutDownloadDetails.checksum}}</p>
        <div class="btn-h">
          <a href="{{cutDownloadDetails.url}}" class="pushable-icon orange-push" [attr.aria-label]="('licenseValidation.step1.button' | translate) + ' ' + ('dashboard.section2.subtitle.ceceut' | translate)">
            <span class="front">
              <span>{{'licenseValidation.step1.button' | translate}}</span><i class="download-icon"></i>
            </span>
          </a>
        </div>
      </div>
    </div>
    <div class="download-choice info-card" role="listitem">
      <img src="assets/img/icons/ios.svg" aria-hidden="true" alt="iOS">
      <div>
        <p class="large">{{'dashboard.section2.subtitle.ceceie' | translate}}</p>
        <p class="extra-small"><strong>{{'dashboard.section2.subtitle.sha' | translate}}</strong> {{downloadsDetails?.ceceieApp.checksum}}</p>
        <div class="btn-h">
          <a href="{{downloadsDetails?.ceceieApp.link}}" class="pushable-icon orange-push" [attr.aria-label]="('dashboard.section2.subtitle.ceceie' | translate)">
            <span class="front">
              <span>{{'licenseValidation.step1.button' | translate}}</span><i class="download-icon"></i>
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="softwareChoiceCut" class="software-choices" role="list">
    <div class="download-choice info-card" role="listitem">
      <img src="assets/img/icons/windows.svg" aria-hidden="true" alt="Windows">
      <div>
        <p class="large">{{'dashboard.section2.subtitle.ceceut' | translate}}</p>
        <p class="extra-small"><strong>{{'dashboard.section2.subtitle.sha' | translate}}</strong> {{cutDownloadDetails.checksum}}</p>
        <div class="btn-h">
          <a href="{{cutDownloadDetails.url}}" class="pushable-icon orange-push" [attr.aria-label]="('licenseValidation.step1.button' | translate) + ' ' + ('dashboard.section2.subtitle.ceceut' | translate)">
            <span class="front">
              <span>{{'licenseValidation.step1.button' | translate}}</span><i class="download-icon"></i>
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="softwareChoiceApk" class="software-choices" role="list">
    <div class="download-choice info-card" role="listitem">
      <img src="assets/img/icons/android.svg" aria-hidden="true" alt="Android">
      <div>
        <p class="large">{{'dashboard.section2.subtitle.ceceae' | translate}}</p>
        <p class="extra-small"><strong>{{'dashboard.section2.subtitle.sha' | translate}}</strong> {{downloadsDetails?.cecemdApp.checksum}}</p>
        <div class="btn-h">
          <a href="{{downloadsDetails?.cecemdApp.linkApk}}" class="pushable-icon orange-push" [attr.aria-label]="('dashboard.section2.subtitle.ceceae' | translate)">
            <span class="front">
              <span>{{'licenseValidation.step1.button' | translate}}</span><i class="download-icon"></i>
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
